import { ORGANIZATION } from "../actions/utilities";

const INITIAL_STATE = {
  getOrganizaionLoading: false,
  getOrganizaionSuccess: false,
  getOrganizaionFailure: false,
  getOrganizaionError: null,
  activeOrganizaionLoading: false,
  activeOrganizaionSuccess: false,
  activeOrganizaionFailure: false,
  activeOrganizaionError: null,
  organizationList: [],
  // activeOrganization: [],

  setUserOrganizaionLoading: false,
  setUserOrganizaionSuccess: false,
  setUserOrganizaionFailure: false,
};
export const organizationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ORGANIZATION.GET_ORGANIZATION_REQUEST:
      return {
        ...state,
        getOrganizaionLoading: true,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
      };
    case ORGANIZATION.GET_ORGANIZATION_SUCCESS:
      let list = [];
      if (action?.payload?.length > 0) {
        list = action.payload;
      }
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: true,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
        organizationList: list,
      };
    case ORGANIZATION.GET_ORGANIZATION_FAILURE:
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: true,
        getOrganizaionError: action.payload,
        organizationList: null,
      };
    case ORGANIZATION.ADD_ORGANIZATION_REQUEST:
      return {
        ...state,
        getOrganizaionLoading: true,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: true,
        getOrganizaionError: null,
      };
    case ORGANIZATION.ADD_ORGANIZATION_SUCCESS:
      let addOrganization = state.organizationList;
      addOrganization.unshift(action.payload);
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: true,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
        organizationList: addOrganization,
      };
    case ORGANIZATION.ADD_ORGANIZATION_FAILURE:
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: true,
        getOrganizaionError: action.payload,
        // organizationList: null,
      };
    case ORGANIZATION.EDIT_ORGANIZATION_REQUEST:
      return {
        ...state,
        getOrganizaionLoading: true,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
      };
    case ORGANIZATION.EDIT_ORGANIZATION_SUCCESS:
      let editOrganization = state.organizationList;
      for (var i = 0; i < editOrganization.length; i++) {
        if (
          editOrganization[i].organizationId === action.payload.organizationId
        ) {
          editOrganization[i] = action.payload;
        }
      }
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: true,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
        organizationList: editOrganization,
      };
    case ORGANIZATION.EDIT_ORGANIZATION_FAILURE:
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: true,
        getOrganizaionError: action.payload,
        // organizationList: null,
      };
    case ORGANIZATION.ACTIVE_ORGANIZATION_REQUEST:
      return {
        ...state,
        activeOrganizaionLoading: true,
        activeOrganizaionSuccess: false,
        activeOrganizaionFailure: false,
        activeOrganizaionError: null,
      };
    case ORGANIZATION.ACTIVE_ORGANIZATION_SUCCESS:
      // let activeOrganization = state.organizationList;
      // for (var j = 0; activeOrganization.length > 0; j++) {
      //   if (activeOrganization[j]?.userId === action.payload?.userId) {
      //     activeOrganization[j] = action.payload;
      //   }
      // }
      return {
        ...state,
        activeOrganizaionLoading: false,
        activeOrganizaionSuccess: true,
        activeOrganizaionFailure: false,
        activeOrganizaionError: null,
        // organizationList: activeOrganization,
      };
    case ORGANIZATION.ACTIVE_ORGANIZATION_FAILURE:
      return {
        ...state,
        activeOrganizaionLoading: false,
        activeOrganizaionSuccess: false,
        activeOrganizaionFailure: false,
        activeOrganizaionError: null,
        // activeOrganization: null,
      };

    case ORGANIZATION.DELETE_ORGANIZATION_REQUEST:
      return {
        ...state,
        getOrganizaionLoading: true,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
      };
    case ORGANIZATION.DELETE_ORGANIZATION_SUCCESS:
      let orgDelete = state.organizationList;
      let payload = orgDelete.filter(
        (item) => item.organizationId != action.payload
      );
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: true,
        getOrganizaionFailure: false,
        getOrganizaionError: null,
        organizationList: payload,
      };
    case ORGANIZATION.DELETE_ORGANIZATION_FAILURE:
      return {
        ...state,
        getOrganizaionLoading: false,
        getOrganizaionSuccess: false,
        getOrganizaionFailure: true,
        getOrganizaionError: action.payload,
      };
    case ORGANIZATION.SET_USER_ORGANIZATION_REQUEST:
      return {
        ...state,
        setUserOrganizaionLoading: true,
        setUserOrganizaionSuccess: false,
        setUserOrganizaionFailure: false,
        setUserOrganizaionError: null,
      };
    case ORGANIZATION.SET_USER_ORGANIZATION_SUCCESS:
      return {
        ...state,
        setUserOrganizaionLoading: false,
        setUserOrganizaionSuccess: true,
        setUserOrganizaionFailure: false,
        setUserOrganizaionError: null,
      };
    case ORGANIZATION.SET_USER_ORGANIZATION_FAILURE:
      return {
        ...state,
        setUserOrganizaionLoading: false,
        setUserOrganizaionSuccess: false,
        setUserOrganizaionFailure: true,
        setUserOrganizaionError: action.payload,
      };
    default:
      return state;
  }
};
